<template>
    <div v-if="visible" class="modal-overlay" @click.self="emit('close')">
      <div class="modal-window">
  
        <h2 class="modal-title">Удалить вакансию?</h2>
        <p class="modal-text">
          Это действие необратимо. Вакансия исчезнет из выдачи и её нельзя будет восстановить.
        </p>
  
        <div class="modal-buttons">
          <button class="btn-cancel" @click="emit('close')">
            Отмена
          </button>
  
          <button class="btn-delete" @click="emit('confirm')">
            🗑 Удалить
          </button>
        </div>
  
      </div>
    </div>
  </template>
  
  <script setup>
  const emit = defineEmits(["confirm", "close"]);
  defineProps({
    visible: Boolean
  });
  </script>
  
  <style scoped>
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.55);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
  }
  
  .modal-window {
    width: 360px;
    background: white;
    padding: 28px 26px;
    border-radius: 18px;
    text-align: center;
    animation: popIn .25s ease;
  }
  
  @keyframes popIn {
    0% { transform: scale(.8); opacity: 0; }
    100% { transform: scale(1); opacity: 1; }
  }
  
  .modal-title {
    font-size: 18px;
    font-family: "Eastman-Bold";
    margin-bottom: 12px;
    color: black;
  }
  
  .modal-text {
    font-size: 13px;
    font-family: "Eastman-Regular";
    color: #444;
    margin-bottom: 26px;
  }
  
  .modal-buttons {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }
  
  .btn-cancel {
    flex: 1;
    padding: 12px;
    border-radius: 12px;
    background: #E6E6E6;
    border: none;
    cursor: pointer;
    font-family: "Eastman-Medium";
    transition: 0.2s;
  }
  
  .btn-cancel:hover {
    background: #DADADA;
  }
  
  .btn-delete {
    flex: 1;
    padding: 12px;
    border-radius: 12px;
    background: linear-gradient(90deg, #E52E2E, #B71C1C);
    color: white;
    border: none;
    cursor: pointer;
    font-family: "Eastman-Bold";
    transition: 0.2s;
  }
  
  .btn-delete:hover {
    opacity: .9;
  }
  </style>